import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SideModal from "/src/components/modal/SideModal/SideModal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from "/src/components/UI/Field/Field";
import TextInput from "/src/components/UI/TextField/TextInput";
import Button from "/src/components/UI/Button/Button";
import { useForm } from "react-hook-form";
import criteriaAdminService from "../../services/criteriaAdminService";

const CriteriaCategoryModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const { createCategory, updateCategory } = criteriaAdminService;

    const { register, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: "onChange",
        defaultValues: { name: data?.name || "" },
    });

    const onSubmit = async (values) => {
        const [response, error] = data
            ? await updateCategory(data.id, values)
            : await createCategory(values);

        if (error) {
            console.error(error);
            return;
        }
        modal.resolve(response);
        onClose();
    };

    return (
        <SideModal name="criteria-category-modal" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="button-leave" id="close_modal_container" onClick={() => onClose()}>
                <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{title}</Form.Title>
                <Form.Body>
                    <Field label={<span>Name <span className="obligatory_field">*</span></span>}>
                        <TextInput {...register("name", { required: true })} />
                        <span className="error-display">{errors.name ? "Name is required" : ""}</span>
                    </Field>
                </Form.Body>
                <Form.Buttons>
                    <Button type="submit" label="Save" className="validate" disabled={!isValid} />
                </Form.Buttons>
            </Form>
        </SideModal>
    );
});

export default CriteriaCategoryModal;
